import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";
import { ArrowRight } from "lucide-react";

const CATEGORIES = ["Basics", "Child Cochlear Implant", "Adult Cochlear Implant", "Surgery", "Mapping & Activation", "Rehabilitation", "Cost & Funding", "Eligibility", "Technology & Products", "Myths & FAQs"];

export default function KnowledgeCentre() {
  const [articles, setArticles] = useState([]);
  const [filter, setFilter] = useState(null);
  useEffect(() => { api.get("/articles", { params: filter ? { category: filter } : {} }).then(({ data }) => setArticles(data)).catch(() => {}); }, [filter]);

  return (
    <>
      <SEO title="Cochlear Implant Knowledge Centre" description="Browse expert-reviewed cochlear implant articles for parents and adults — basics, surgery, mapping, therapy, cost, technology and myths." />
      <section className="bg-gradient-to-br from-[#F0F9FF] via-white to-[#ECFDF5] py-14">
        <div className="hc-container max-w-4xl">
          <h1 className="font-serif text-[2.25rem] md:text-[3rem] font-semibold leading-[1.08] text-slate-900">Knowledge Centre</h1>
          <p className="mt-5 text-slate-700 text-[1.05rem]">Expert-reviewed articles in clear, parent-friendly language. Every article reviewed by the HearClear clinical editorial team.</p>
        </div>
      </section>

      <section className="hc-container py-10">
        <div className="flex flex-wrap gap-2">
          <button data-testid="kc-filter-all" onClick={() => setFilter(null)} className={`px-3.5 py-2 rounded-full text-[13.5px] font-medium border ${!filter ? "bg-[#0369A1] text-white border-[#0369A1]" : "bg-white border-slate-200 text-slate-700 hover:border-[#0369A1]"}`}>All</button>
          {CATEGORIES.map((c) => (
            <button key={c} data-testid={`kc-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`} onClick={() => setFilter(c)} className={`px-3.5 py-2 rounded-full text-[13.5px] font-medium border ${filter === c ? "bg-[#0369A1] text-white border-[#0369A1]" : "bg-white border-slate-200 text-slate-700 hover:border-[#0369A1]"}`}>{c}</button>
          ))}
        </div>

        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((a) => (
            <Link key={a.id} to={`/article/${a.slug}`} data-testid={`article-${a.slug}`} className="card-hc block">
              <div className="text-[11px] uppercase tracking-wider font-bold text-[#0F766E]">{a.category}</div>
              <div className="mt-2 font-serif text-lg font-semibold text-slate-900 leading-snug">{a.title}</div>
              <p className="mt-3 text-slate-600 text-[14.5px] leading-relaxed line-clamp-3">{a.summary}</p>
              <div className="mt-4 text-[#0369A1] font-semibold text-sm inline-flex items-center gap-1">Read article <ArrowRight size={14} /></div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
